import React from "react";

// Subtle abstract concentric gold ring background. No people, no spiritual symbols.
export const BackgroundRings = ({ opacity = 0.06, position = "right" }) => {
    const positionStyles =
        position === "center"
            ? { left: "50%", top: "50%", transform: "translate(-50%, -50%)" }
            : position === "left"
              ? { left: "-10%", top: "50%", transform: "translate(0, -50%)" }
              : { right: "-15%", top: "50%", transform: "translate(0, -50%)" };

    return (
        <div
            aria-hidden="true"
            data-testid="background-rings"
            style={{
                position: "absolute",
                inset: 0,
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: 0,
            }}
        >
            <svg
                width="900"
                height="900"
                viewBox="0 0 900 900"
                style={{ position: "absolute", ...positionStyles }}
            >
                {[...Array(10)].map((_, i) => (
                    <circle
                        key={i}
                        cx="450"
                        cy="450"
                        r={60 + i * 38}
                        fill="none"
                        stroke="#c9a227"
                        strokeOpacity={opacity * (1 - i * 0.07)}
                        strokeWidth="1"
                    />
                ))}
                <circle cx="450" cy="450" r="6" fill="#c9a227" fillOpacity="0.5" />
            </svg>
            <div className="grain" />
        </div>
    );
};

export default BackgroundRings;
